// extracted by mini-css-extract-plugin
export var active = "_ty-1";
export var circle = "_ty-0";
export var completed = "_ty-2";
export var connector = "_ty-4";
export var connectorCompleted = "_ty-7";
export var connectorSpacer = "_ty-5";
export var iconStrokeOverride = "_ty-8";
export var labelContainer = "_ty-6";
export var pending = "_ty-3";